"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./SponsoredListingWhy.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-313":{"id":"e-313","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-314"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a7f3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a7f3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":150,"direction":"BOTTOM","effectIn":true},"createdOn":1694027505001},"e-315":{"id":"e-315","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-316"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a7f5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a7f5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1694027505001},"e-317":{"id":"e-317","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-318"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a7f7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a7f7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":320,"direction":"BOTTOM","effectIn":true},"createdOn":1694027505001},"e-319":{"id":"e-319","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-320"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a7fc","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a7fc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":340,"direction":"BOTTOM","effectIn":true},"createdOn":1694027505001},"e-321":{"id":"e-321","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-322"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a801","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a801","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":360,"direction":"BOTTOM","effectIn":true},"createdOn":1694027505001},"e-323":{"id":"e-323","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-324"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a807","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a807","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1694027505001},"e-325":{"id":"e-325","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-326"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a809","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a809","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1694027505001},"e-327":{"id":"e-327","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SHRINK_EFFECT","instant":false,"config":{"actionListId":"shrinkIn","autoStopEventId":"e-328"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a80d","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a80d","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1694027505001},"e-329":{"id":"e-329","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SHRINK_EFFECT","instant":false,"config":{"actionListId":"shrinkIn","autoStopEventId":"e-330"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a80e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a80e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":null,"effectIn":true},"createdOn":1694027505001},"e-331":{"id":"e-331","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-332"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a810","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a810","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":400,"direction":"LEFT","effectIn":true},"createdOn":1694027505001},"e-333":{"id":"e-333","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-334"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a812","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3834a7fd-5dbc-c028-b0d5-b96fdd00a812","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":600,"direction":"RIGHT","effectIn":true},"createdOn":1694027505001}},"actionLists":{"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]},"shrinkIn":{"id":"shrinkIn","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":1.25,"yValue":1.25}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":1,"yValue":1}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]},"slideInLeft":{"id":"slideInLeft","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":-100,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}},{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]}]},"slideInRight":{"id":"slideInRight","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":100,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}},{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function SponsoredListingWhy({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "sponsored-listings-why", "new")}
      grid={{
        type: "section",
      }}
      tag="section"
      id="SponsoredListingWhy"
    >
      <_Builtin.Container
        className={_utils.cx(_styles, "home-start-project-container")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "sponsored-listings-how-block", "new")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "sponsored-listings-how-grid")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "sponsored-listings-why-text")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "inline-text", "light")}
                tag="div"
              >
                <_Builtin.Heading
                  className={_utils.cx(_styles, "heading")}
                  data-w-id="3834a7fd-5dbc-c028-b0d5-b96fdd00a7f3"
                  tag="h2"
                >
                  {"Why boost your listing?"}
                </_Builtin.Heading>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "sponsored-listings-how-actions")}
              data-w-id="3834a7fd-5dbc-c028-b0d5-b96fdd00a7f5"
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "sponsored-listings-why-checklist-block",
                  "new"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "checklist-text-block",
                    "box-one",
                    "new"
                  )}
                  data-w-id="3834a7fd-5dbc-c028-b0d5-b96fdd00a7f7"
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "tick-check-list")}
                    tag="div"
                  >
                    <_Builtin.Image
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64f8eb2b154732b5e6c14073_ribbon-icon.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Paragraph
                    className={_utils.cx(
                      _styles,
                      "sponsored-listings-pricing-list-text",
                      "light"
                    )}
                  >
                    {
                      "Put your listing at the top of liv.rent's search engine-optimized pages"
                    }
                  </_Builtin.Paragraph>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "checklist-text-block",
                    "box-two",
                    "new"
                  )}
                  data-w-id="3834a7fd-5dbc-c028-b0d5-b96fdd00a7fc"
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "tick-check-list")}
                    tag="div"
                  >
                    <_Builtin.Image
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64f8eb3b7f0db12eea9742ad_rocket-icon.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Paragraph
                    className={_utils.cx(
                      _styles,
                      "sponsored-listings-pricing-list-text",
                      "light"
                    )}
                  >
                    {"Maximize exposure by advertising on multiple sites"}
                  </_Builtin.Paragraph>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "checklist-text-block",
                    "box-two",
                    "new"
                  )}
                  data-w-id="3834a7fd-5dbc-c028-b0d5-b96fdd00a801"
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "tick-check-list")}
                    tag="div"
                  >
                    <_Builtin.Image
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64f8eb443a5fcd1ea52831dd_bolt-icon.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Paragraph
                    className={_utils.cx(
                      _styles,
                      "sponsored-listings-pricing-list-text",
                      "light"
                    )}
                  >
                    {"Find qualified and relevant tenants quicker and easier"}
                  </_Builtin.Paragraph>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "inline-text")}
              tag="div"
            >
              <_Builtin.Paragraph
                className={_utils.cx(
                  _styles,
                  "home-project-paragraph",
                  "light"
                )}
                data-w-id="3834a7fd-5dbc-c028-b0d5-b96fdd00a807"
              >
                {"Starting at just $1.79/day. "}
              </_Builtin.Paragraph>
              <_Builtin.Paragraph
                className={_utils.cx(
                  _styles,
                  "home-project-paragraph",
                  "light"
                )}
                data-w-id="3834a7fd-5dbc-c028-b0d5-b96fdd00a809"
              >
                <_Builtin.Link
                  className={_utils.cx(_styles, "link-3")}
                  button={false}
                  id="sl-anchor-getstarted"
                  block=""
                  options={{
                    href: "/boost-a-listing?accountType=essentials",
                  }}
                >
                  {"Get started"}
                </_Builtin.Link>
              </_Builtin.Paragraph>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "image-hero-banner")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "service-banner")}
              data-w-id="3834a7fd-5dbc-c028-b0d5-b96fdd00a80d"
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "service-banner-main-image")}
                data-w-id="3834a7fd-5dbc-c028-b0d5-b96fdd00a80e"
                tag="div"
              >
                <_Builtin.Image
                  className={_utils.cx(_styles, "service-banner-main")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e676031b743d511d168e18_banner%20stock%20photo.webp"
                />
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "project-completed")}
                data-w-id="3834a7fd-5dbc-c028-b0d5-b96fdd00a810"
                tag="div"
              >
                <_Builtin.Image
                  className={_utils.cx(_styles, "project-number")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e676027b8486638cb06074_banner%20listing.webp"
                />
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "solutions-percentage")}
                data-w-id="3834a7fd-5dbc-c028-b0d5-b96fdd00a812"
                tag="div"
              >
                <_Builtin.Image
                  className={_utils.cx(_styles, "solutions-peracentage-image")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e6760261ede82b69801df1_banner%20stats.webp"
                />
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Container>
    </_Component>
  );
}
